import React, { type FC } from "react";
import { SettingsAssessorsPage } from "./Settings/SettingsAssessorsPage";
import { SettingsCertificationTypesPage } from "./Settings/SettingsCertificationTypesPage";
import { SettingsEmailImportPage } from "./Settings/SettingsEmailImportPage";
import { SettingsUsersPage } from "./Settings/SettingsUsersPage";

export const AssessorsPage: FC<{}> = (props) => {
  return (
    <div className={"flex flex-col space-y-4"}>
      <SettingsAssessorsPage />
      <SettingsUsersPage />
      <SettingsEmailImportPage />
      <SettingsCertificationTypesPage />
    </div>
  );
};
